import React, { useEffect, useState } from "react";
import ActivityChat from "../activity-chat";
import AttendessChat from "../attendees-chat";
import Chatbox from "../box-chat";
import {
  Activity,
  ActivityInactive,
  Contact,
  ContactInactive,
  Chatnew,
  ChatnewInactive,
  ActivityInactiveZyia,
  ActivityInactiveMA,
  ActivityInactiveYoli,
  ActivityInactiveDefault,
} from "../../../../assets/icons";
import useAppAccessor from "../../../../hooks/useappAccessor";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { showIsAttendeeList } from "../../../agora-live/components/streamControls/controls.actions";
import {
  getBrandChatIcon,
  getBrandChatIconInactive,
} from "../../../../utils/brand.util";

const isHost = () => {
  return window.location.href.indexOf("/stream") > -1;
};

const HeaderChat = ({
  activeTab,
  onChangeActiveTab,
  dynamicHeader,
}: {
  activeTab: string;
  onChangeActiveTab: any;
  dynamicHeader: any;
}) => {
  const dispatch = useAppDispatch();
  const { getControls, getUserData } = useAppAccessor();
  const { client } = getUserData();
  const { isShowAttendeeList } = getControls();

  const checkBrand = (client: any) => {
    switch (client) {
      case "marketamerica": {
        return (
          <img
            src={activeTab === "activity" ? getBrandChatIconInactive(client) : ActivityInactiveMA}
            className={`cursor-pointer py-2 px-4 ${
              activeTab === "activity"
                ? "text-white text-bold text-xl "
                : "text-purple-500 text-bold text-xl"
            }`}
            onClick={() => {
              onChangeActiveTab("activity");
              dispatch(showIsAttendeeList(false));
            }}
          ></img>
        );
      }
      case "zyiaactive": {
        return (
          <img
            src={activeTab === "activity" ? getBrandChatIconInactive(client) : ActivityInactiveZyia}
            className={`cursor-pointer py-2 px-4 ${
              activeTab === "activity"
                ? "text-white text-bold text-xl "
                : "text-purple-500 text-bold text-xl"
            }`}
            onClick={() => {
              onChangeActiveTab("activity");
              dispatch(showIsAttendeeList(false));
            }}
          ></img>
        );
      }
      case "beyondslim": {
        return (
          <img
            src={activeTab === "activity" ? getBrandChatIconInactive(client) : ActivityInactive}
            className={`cursor-pointer py-2 px-4 ${
              activeTab === "activity"
                ? "text-white text-bold text-xl "
                : "text-purple-500 text-bold text-xl"
            }`}
            onClick={() => {
              onChangeActiveTab("activity");
              dispatch(showIsAttendeeList(false));
            }}
          ></img>
        );
      }
      case "Yoli": {
        return (
          <img
            src={activeTab === "activity" ? getBrandChatIconInactive(client) : ActivityInactiveYoli}
            className={`cursor-pointer py-2 px-4 ${
              activeTab === "activity"
                ? "text-white text-bold text-xl "
                : "text-purple-500 text-bold text-xl"
            }`}
            onClick={() => {
              onChangeActiveTab("activity");
              dispatch(showIsAttendeeList(false));
            }}
          ></img>
        );
      }
      case "Verb": {
        return (
          <img
            src={activeTab === "activity" ? getBrandChatIconInactive(client) : ActivityInactiveDefault}
            className={`cursor-pointer py-2 px-4 ${
              activeTab === "activity"
                ? "text-white text-bold text-xl "
                : "text-purple-500 text-bold text-xl"
            }`}
            onClick={() => {
              onChangeActiveTab("activity");
              dispatch(showIsAttendeeList(false));
            }}
          ></img>
        );
      }

      case "Hussle": {
        return (
          <img
            src={activeTab === "activity" ? getBrandChatIconInactive(client) : ActivityInactiveDefault}
            className={`cursor-pointer py-2 px-4 ${
              activeTab === "activity"
                ? "text-white text-bold text-xl "
                : "text-purple-500 text-bold text-xl"
            }`}
            onClick={() => {
              onChangeActiveTab("activity");
              dispatch(showIsAttendeeList(false));
            }}
          ></img>
        );
      }

      default:
        return (
          <img
            src={activeTab === "activity" ? getBrandChatIconInactive(client) : ActivityInactive}
            className={`cursor-pointer py-2 px-4 ${
              activeTab === "activity"
                ? "text-white text-bold text-xl "
                : "text-purple-500 text-bold text-xl"
            }`}
            onClick={() => {
              onChangeActiveTab("activity");
              dispatch(showIsAttendeeList(false));
            }}
          ></img>
        );
    }
  };


  useEffect(() => {
    if (isShowAttendeeList) {
      onChangeActiveTab("attendees");
    }
  }, [isShowAttendeeList]);
  return (
    <>
      <div
        className="flex w-full h-full items-center justify-center border-b border-[#2A2A2A]"
        style={{ backgroundColor: "#1F1F1F", height: 64 }}
      >
        <div
          className="flex w-full pl-7 pr-7 pt-2 items-center"
          style={{ justifyContent: "space-around" }}
        >
          {/* <p
            className={`cursor-pointer py-2 px-4 ${
              activeTab === "chat"
                ? "text-white text-bold text-xl border-b-2 border-white pt-3"
                : "text-purple-500 text-bold text-xl pt-3"
            }`}
            onClick={() => onChangeActiveTab("chat")}
          >
            {dynamicHeader("chat")}
          </p> */}
          <img
            src={activeTab === "chat" ? getBrandChatIcon(client) : getBrandChatIcon(client)}
            className={`cursor-pointer py-2 px-4 ${
              activeTab === "chat"
                ? "text-white text-bold text-xl "
                : "text-purple-500 text-bold text-xl "
            }`}
            onClick={() => {
              onChangeActiveTab("chat");
              dispatch(showIsAttendeeList(false));
            }}
          ></img>
          {/* <p
            className={`cursor-pointer py-2 px-4 ${
              activeTab === "attendees"
                ? "text-white text-bold text-xl border-b-2 border-white pt-3"
                : "text-purple-500 text-bold text-xl pt-3"
            }`}
            onClick={() => onChangeActiveTab("attendees")}
          >
            {dynamicHeader("attendees")}
          </p> */}
          {/* {
            isHost() && <div className="border-l-[0.5px] border-[#DEDEDE]/[0.4] h-[40px]"></div>
          }
          {
            isHost() && <img src={activeTab === "attendees"?Contact:ContactInactive}
            className={`cursor-pointer py-2 px-4 ${
             activeTab === "attendees"
               ? "text-white text-bold text-xl "
               : "text-purple-500 text-bold text-xl"
           }`}
            
           onClick={() => onChangeActiveTab("attendees")}></img>
          } */}
          {/* <div className="border-l-[0.5px] border-[#DEDEDE]/[0.4] h-[40px]"></div> */}
          {/* {checkBrand(client)} */}
        </div>
      </div>
    </>
  );
};

export default HeaderChat;
